export enum StoreTypes {
  invitedUsers = 'invitedUsers',
  users = 'users',
}
